import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Form, InputNumber } from 'tdesign-react';
import styled from 'styled-components';
import { deal70101, isEmpty } from '@/utils/common';
import { updateClientLimitPolicy } from '@/services/topicService';
import { fetchProPolices } from '@/slices/topicSlice';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';

const { FormItem } = Form;

function Modal({ visible, handleClose, detail, commonProps, fetchProPolices }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      form.reset();
      form.setFieldsValue(detail);
    }
  }, [form, visible, detail]);

  const onCancel = () => {
    handleClose();
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const { meta } = await updateClientLimitPolicy({
          ...commonProps,
          ...fields,
        });
        // 主集群创建的资源已在灾备集群存在
        if (meta.code === 70101) {
          deal70101(meta.publicMessage, () => handleSubmit({ validateResult, fields }), {
            url: '/cluster/topic/list',
            topic: commonProps.topic,
          });
          return;
        }
        await fetchProPolices(commonProps);
        handleClose();
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Root
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      header='数量限制'
      width={550}
      onClose={onCancel}
    >
      <Form form={form} onSubmit={handleSubmit} style={{ width: '94%' }} labelWidth={180}>
        <FormItem
          name='maxProducers'
          label='最大Producer数'
          rules={[
            { required: true },
            { validator: (val) => isEmpty(val) || val >= 0, message: '请输入不小于0的值' },
          ]}
        >
          <InputNumber theme='normal' decimalPlaces={0} />
        </FormItem>
        <FormItem
          name='maxConsumers'
          label='最大Consumer数'
          rules={[
            { required: true },
            { validator: (val) => isEmpty(val) || val >= 0, message: '请输入不小于0的值' },
          ]}
        >
          <InputNumber theme='normal' decimalPlaces={0} />
        </FormItem>
      </Form>
    </Root>
  );
}

export default connect(null, {
  fetchProPolices,
})(Modal);

const Root = styled(Dialog)`
  .t-input-number {
    width: auto;
    flex: 1;
  }
  .t-input__suffix {
    color: var(--td-font-gray-2);
  }
`;
